/*
***********************************************************
** MixInsGesstioneTraduzioni - Gestione delle traduzioni
** Versione 1.0.0 28 Febbraio 2025
**                - Prima versione
***********************************************************
*/

export default
{
  methods: 
  {
    ProceduraTraduzione()
    {
      console.log(window.TRADUZIONI_LINGUE)
    },

    GetTraduzioneLabel(Sezione, Token, Lingua, Default = '??????')
    {
      if(window.TRADUZIONI_LINGUE != null)
      {
        for (let i = 0; i < window.TRADUZIONI_LINGUE.length; i++)
        {
          if(window.TRADUZIONI_LINGUE[i].Lingua == Lingua)
          {
            let ChiaveLingua = window.TRADUZIONI_LINGUE[i].Chiave
            for (let j = 0; j < window.TRADUZIONI_LINGUE[i].Sezioni.length; j++)
            {
              if(window.TRADUZIONI_LINGUE[i].Sezioni[j].Sezione == Sezione)
              {
                for (let k = 0; k < window.TRADUZIONI_LINGUE[i].Sezioni[j].Traduzioni.length; k++)
                {
                  if(window.TRADUZIONI_LINGUE[i].Sezioni[j].Traduzioni[k].Token == Token)
                  {
                    if(window.TRADUZIONI_LINGUE[i].Sezioni[j].Traduzioni[k]['Lingua' + ChiaveLingua] != null)
                      return window.TRADUZIONI_LINGUE[i].Sezioni[j].Traduzioni[k]['Lingua' + ChiaveLingua]
                    return window.TRADUZIONI_LINGUE[i].Sezioni[j].Traduzioni[k].ValoreSuggerito;
                  }
                }
              }
            }
          }
        }
      }
      return Default;
    }

  }
}